import { Grid, makeStyles } from "@material-ui/core";
import { Button, TextButton } from "../../../components/base/Button";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(4),
    width: "fit-content",
  },
}));

export const GroupButton = ({ buttons, additionalEl }) => {
  const classes = useStyles();

  return (
    <Grid className={classes.root} container alignItems="center">
      <Button text={buttons[0].text} onClick={buttons[0].onClick} />
      {buttons.slice(1).map((button, index) => (
        <TextButton
          key={index}
          text={button.text}
          onClick={button.onClick}
          style={{ marginLeft: 30 }}
        />
      ))}
      {additionalEl}
    </Grid>
  );
};
